import fetch from "lib/fetch";

export const validateRegisterStepRequest = (stepName: string, data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>(`register/validate/${stepName}`, data);

export const createRegisterCompanyRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/company", data);

export const updateRegisterKnowPlatformRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<{ data: unknown }>(`register/know_platform/${id}`, data);

export const createRegisterUserRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/user", data);

export const validateRegisterClientInformationsRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/user/informations", data);

export const validateRegisterClientCesuRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>(`register/user/cesu`, data);

export const createRegisterProviderRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider", data);

export const validateRegisterProviderInformationsRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider/informations", data);

export const validateRegisterProviderInformationsProfileRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider/informations_profile", data);

export const validateRegisterProviderCesuRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider/cesu", data);

export const validateRegisterProviderIbanRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider/bank_account", data);

export const trackRegisterProviderProgressRequest = (data: HashMap<unknown>) =>
    fetch.post<{ data: unknown }>("register/provider/progress", data);
